// 请选择选项

export default {
  value: '',
  icon: 'el-icon-thumb',
  label: 'public.please'
}
